import { Button, Flex, Typography, Card } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AddRingotelUserModal from "../../components/Modal/AddRingotelUser";
import { RootState } from "../../store/store";
import RingotelUsersTable from "../../components/Admin/Tables/RingotelUsers";
import { useGetRingotelOrganizations } from "../../hooks/apis/ringotel.api";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useGetAllUsers } from "../../hooks/apis/user.api";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useGetDidUsersByAccount } from "../../hooks/apis/userDids";
const RingotelUsers = () => {

  const [account_id, setAccountId] = useState<string | null>(null);
  const [addRingotelUserModal, setAddRingotelUserModal] = useState(false);

  const { data: ringotelOrgs } = useSelector((state: RootState) => state.ringotelOrgs);
  const { allUsers: users } = useSelector((state: RootState) => state.users);
  const { accounts, selectedAccount } = useSelector((state: RootState) => state.admin);

  const { refetch: refetchRingotelOrganization } = useGetRingotelOrganizations();
  const { refetch: fetchAllUsers } = useGetAllUsers();
  const { refetch: fetchUserDids } = useGetDidUsersByAccount(selectedAccount)


  useEffect(() => {
    if (selectedAccount) {
      fetchUserDids()
    }
  }, [selectedAccount])


  const navigate: NavigateFunction = useNavigate();

  useEffect(() => {
    refetchRingotelOrganization();
  }, []);

  useEffect(() => {
    setAccountId(ringotelOrgs[0]?.account_id ? ringotelOrgs[0]?.account_id : "");
  }, [ringotelOrgs]);

  useEffect(() => {
    if (users.length == 0) {
      fetchAllUsers();
    }
  }, []);


  return (
    <div style={{ width: "100%", maxWidth: "100%", overflow: "hidden" }}>
      <Flex vertical gap={10} style={{ padding: "20px", width: "100%" }}>
        {addRingotelUserModal && account_id && <AddRingotelUserModal setIsModalOpen={setAddRingotelUserModal} isModalOpen={addRingotelUserModal} />}
        <IoMdArrowRoundBack onClick={() => navigate("/integrations")} style={{ color: "#1890ff", fontSize: "20px", cursor: "pointer" }} />
        <Flex justify="space-between" align="center" style={{ padding: "10px" }}>
          <Typography.Title>{`Ringotel Users`}</Typography.Title>{" "}
          <Flex gap={10}>
            {account_id && ringotelOrgs.length > 0 && (
              <Button
                type="primary"
                onClick={() => {
                  setAddRingotelUserModal(true);
                }}
              >
                Add Ringotel User
              </Button>
            )}
            <Button
              type="primary"
              onClick={() => {
                navigate("/ringotel-orgs");
              }}
            >
              Ringotel Organizations
            </Button>
          </Flex>
        </Flex>
        {selectedAccount && ringotelOrgs.length > 0 && (
          <Card style={{ marginBottom: "20px" }}>
            <Flex gap={20} align="center">
              <div>
                <Typography.Text strong>Organization: </Typography.Text>
                <Typography.Text copyable>
                  {ringotelOrgs.find(org => org.account_id === selectedAccount)?.orgid || 'N/A'}
                </Typography.Text>
              </div>
              <div>
                <Typography.Text strong>Account: </Typography.Text>
                <Typography.Text>
                  {accounts?.find((a) => a.id === selectedAccount)?.name || 'Unknown Account'}
                </Typography.Text>
              </div>
            </Flex>
          </Card>
        )}
        <div style={{ marginTop: "20px", width: "100%", overflow: "hidden" }}>
          <RingotelUsersTable />
        </div>
      </Flex>
    </div>
  );
};
export default RingotelUsers;
